const translations = {
  "en": {
    "Add Assets": "Add Assets",
    "Add Assets Manually": "Add Assets Manually",
    "Add your holdings so I can start building around you. I'll learn to think like you, and get smarter to keep you unstoppable.": "Add your holdings so I can start building around you. I'll learn to think like you, and get smarter to keep you unstoppable.",
    "Connect your broker or wallet and I'll import everything automatically.": "Connect your broker or wallet and I'll import everything automatically.",
    "Create": "Create",
    "Crypto": "Crypto",
    "Enter your stocks and crypto yourself and I'll track it all for you.": "Enter your stocks and crypto yourself and I'll track it all for you.",
    "Get started with your first portfolio!": "Get started with your first portfolio!",
    "Link your broker and I'll import all your positions.": "Link your broker and I'll import all your positions.",
    "Link your wallet or exchange to pull in your tokens.": "Link your wallet or exchange to pull in your tokens.",
    "Premium": "Premium",
    "Skip for now": "Skip for now",
    "Stock": "Stock",
    "Sync Your Accounts": "Sync Your Accounts"
  },
  "zh-tw": {
    "Add Assets": "新增資產",
    "Add Assets Manually": "手動新增資產",
    "Add your holdings so I can start building around you. I'll learn to think like you, and get smarter to keep you unstoppable.": "加入你的持倉，讓我能以你為中心開始建構。我會學著像你一樣思考，並變得更聰明，讓你始終無可阻擋。",
    "Connect your broker or wallet and I'll import everything automatically.": "連結你的券商或錢包，我會自動匯入所有內容。",
    "Create": "建立",
    "Crypto": "加密貨幣",
    "Enter your stocks and crypto yourself and I'll track it all for you.": "自己輸入你的股票和加密貨幣，我會為你追蹤所有內容。",
    "Get started with your first portfolio!": "開始建立你的第一個投資組合！",
    "Link your broker and I'll import all your positions.": "連結你的券商，我會匯入你所有的持倉。",
    "Link your wallet or exchange to pull in your tokens.": "連結你的錢包或交易所以匯入你的代幣。",
    "Premium": "高階版",
    "Skip for now": "跳過",
    "Stock": "股票",
    "Sync Your Accounts": "同步你的帳戶"
  }
};

export default translations;
